import React, { useState } from 'react';
import BackRow from 'components/BackRow/BackRow';
import TabRow from 'components/TabRow/TabRow';
import { DeleteDialog, MessageDialog } from 'components/Dialog/Dialog';
import About from './About';
import Questions from './Questions';
import Results from './Results';
import { post, dodelete } from 'lib/comms';
import './MicroLearning.css';
import moment from 'moment';

// export default class MicroLearningPage extends React.Component {
const MicroLearningPage = (props) => {
    const isNew = props.learning && props.learning.id === 'new';
    const learningInit = isNew
        ? {
              id: 'new',
              name: '',
              description: '',
              effort_level: 1,
              time_to_complete: 1,
              posted_date: null,
              //   posted_date: new Date(),
              active: 1,
              out_of: 0,
          }
        : props.learning;

    const [state, setState] = useState({
        learning: learningInit,
        editing: [isNew],
        showDeleteDialog: false,
        showMessage: null,
        isNew,
        activeTab: 'About',
    });

    // constructor(props) {
    //     super(props);
    //     const isNew = props.learning && props.learning.id === 'new';
    //     const learning = isNew
    //         ? {
    //               id: 'new',
    //               name: '',
    //               description: '',
    //               effort_level: 1,
    //               time_to_complete: 1,
    //               posted_date: null,
    //               active: 1,
    //               out_of: 0,
    //           }
    //         : props.learning;
    //     state = {
    //         learning,
    //         editing: [isNew],
    //         showDeleteDialog: false,
    //         showMessage: null,
    //         isNew,
    //         activeTab: 'About',
    //     };
    // }

    const setEditing = async (index) => {
        let { editing, learning } = state;
        if (editing[index]) {
            // save to db
            if (!learning.name) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid title', title: 'Save material' },
                });
            }
            if (!learning.description) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid description', title: 'Save material' },
                });
            }
            const resp = await post('cms/learnings', { learning }, true);
            if (resp && resp.success) {
                props.reload();
                editing[index] = false;
                if (resp.id) {
                    editing[1] = true;
                    learning.id = resp.id;
                    props.updateItemCreated();
                    setState({ ...state, learning, isNew: false, activeTab: 'Questions' });
                }
            } else console.log(resp);
            if (resp.message) {
                setTimeout(
                    () => setState({ ...state, showMessage: { message: resp.message, title: 'Save error' } }),
                    500,
                );
            }
            editing[index] = false;
        } else editing[index] = true;
        setState({ ...state, editing });
    };

    const setAnswers = async ({ content, outOf }) => {
        const learning = { ...state.learning, content, out_of: outOf };
        let { editing } = state;
        editing[1] = false;
        editing[0] = false;
        setState({ ...state, learning, editing });
        const resp = await post('cms/learnings', { learning }, true);
        if (resp.message) {
            setTimeout(() => setState({ ...state, showMessage: { message: resp.message, title: 'Save error' } }), 500);
        }
    };

    const doDelete = async () => {
        const resp = await dodelete('cms/learnings', { id: state.learning.id }, true);
        await setState({ ...state, showDeleteDialog: false });
        if (resp && resp.success && props.onBack) props.onBack();
        else if (resp.message) {
            setTimeout(
                () => setState({ showMessage: { message: resp.message, title: 'Delete Learning Material' } }),
                500,
            );
        }
    };

    const doPost = async () => {
        const learning = { ...state.learning, posted_date: moment().format('YYYY-MM-DD') };
        setState({ learning });
        const resp = await post('cms/learnings', { learning }, true);
        if (resp.message) {
            setTimeout(() => setState({ ...state, showMessage: { message: resp.message, title: 'Save error' } }), 500);
        } else if (resp && resp.success) {
            props.reload();
        }
    };

    let { learning, editing, activeTab } = state;

    if (props.activeTab) {
        activeTab = props.activeTab;
    }

    let tabs = ['About'];
    // if (!isNew && !learning.posted_date) tabs.push('Questions');
    tabs.push('Questions');
    if (learning?.posted_date) tabs.push('Results');

    return (
        <div className="maincontainer">
            <BackRow
                onBack={props.onBack}
                buttonTitle={activeTab === 'About' && !state.isNew ? 'DELETE MATERIAL' : null}
                onDelete={() => setState({ ...state, showDeleteDialog: true })}
            />
            <TabRow onChange={(activeTab) => setState({ ...state, activeTab })} activeTab={activeTab} tabs={tabs} />
            {activeTab === 'About' ? (
                <About
                    learning={learning}
                    editing={editing[0]}
                    onToggle={() => setEditing(0)}
                    onEdit={(what) => setState({ ...state, learning: { ...learning, ...what } })}
                    onPost={doPost}
                />
            ) : null}
            {activeTab === 'Questions' ? (
                <Questions
                    learning={learning}
                    onEdit={setAnswers}
                    editing={editing[1] || props.activeTab === 'Questions' || null}
                    allowEditAnswers={!learning?.posted_date}
                />
            ) : null}
            {activeTab === 'Results' ? <Results learning={learning} /> : null}
            {state.showDeleteDialog ? (
                <DeleteDialog
                    item="Material"
                    onSuccess={doDelete}
                    onClose={() => setState({ ...state, showDeleteDialog: false })}
                />
            ) : null}
            {state.showMessage ? (
                <MessageDialog
                    message={state.showMessage.message}
                    title={state.showMessage.title}
                    onClose={() => setState({ ...state, showMessage: null })}
                />
            ) : null}
        </div>
    );
};

export default MicroLearningPage;
